<script>
import content from '@/content'
import SearchTags from '@/components/SearchTags.vue'

export default {
  name: 'works',

  components: {
    SearchTags
  },

  data() {
    return {
      works: [],
      results: {},
      listeners: {
        queries: {}
      }
    }
  },

  computed: {
    selectedWork() {
      const { workId } = this.$route.params
      return this.works?.find(work => work.id === workId)
    },

    displayResults() {
      const { results, works, selectedWork } = this
      const resultsIds =
        selectedWork?.results ||
        // Display only a part of of the results of each work on the main page
        // if specified.
        works
          .map(({ results, previewResults }) =>
            previewResults !== -1 ? results.slice(0, previewResults) : results
          )
          .flat()
      return resultsIds.map(id => results[id])
    }
  },

  created() {
    this.load()
  },

  methods: {
    async load() {
      const { results, works } = await content.get('works')
      this.results = results
      this.works = works
    },

    selectWork(work) {
      const { selectedWork } = this
      const params = selectedWork?.id === work.id ? {} : { workId: work.id }

      this.$router.push({ name: 'works', params })
    }
  }
}
</script>
